import { gql } from 'apollo-angular'

export const GET_TOTAL_ARTICLES_COUNT = gql`
  query CountArticles {
    countArticles {
      totalDocs
    }
  }
`
